module.exports = __webpack_public_path__ + "img/pic6.93dd8ebd.png";